<template>
  <action-modal
    headline="Select the Wealthbox campaigns you wish to import"
    :button-label="'Select Wealthbox Campaigns'"
    button-type="warning"
    :action-url="actionUrl"
    :action-params="{groups: selectedGroups}"
    :redirect-url="redirectUrl"
    :action-button-wrapper-classes="actionButtonWrapperClasses"
    :action-button-styles="true"
    :disable-button="groups.length === 0"
    disable-button-tooltip="No Wealthbox groups found"
    :open-modal-button-classes="['actionButton', 'wealthboxImportButton']"
    process-type="wealthbox-import"
    @action-processing="onActionProcessing"
    :stringify-params="false"
  >
    <slot>
      <ul class="group-list" :class="{'add-vertical-scroll': groups.length > 3}">
        <li
          v-for="group in groups"
          :key="group.id"
          class="group-entry"
          :class="{selected: selectedGroups.includes(group.id)}"
          :group-id="group.id"
          @click="groupSelected(group)"
        >
          <i v-if="selectedGroups.includes(group.id)" class="fas fa-check-square"></i>
          <i v-else class="fas fa-minus-square"></i>
          {{ group.name }}
        </li>
      </ul>
      <div v-if="contactsCount" class="import-meta">Selected a total of {{ selectedGroups.length }} group(s)</div>
    </slot>
  </action-modal>
</template>

<script>
import ActionModal from '../components/ActionModal';
import {getActiveCrmGroups} from '../utility/crms/getActiveCrmGroups';

export default {
  name: 'wealthbox-import-groups',
  components: {ActionModal},
  data() {
    return {
      groups: [],
      selectedGroups: [],
      contactsCount: 0,
      actionUrl: '',
    };
  },
  methods: {
    groupSelected(group) {
      if (!this.selectedGroups.includes(group.id)) {
        this.selectedGroups.push(group.id);
        this.contactsCount += group.count;
      } else {
        let index = this.selectedGroups.indexOf(group.id);
        this.selectedGroups.splice(index, 1);
        this.contactsCount -= group.count;
      }
    },
    onActionProcessing(data) {
      this.$emit('action-processing', {
        type: data.type,
      });
    },
  },
  mounted() {
    let self = this;

    const onboardingParam = this.onboarding ? '&onboarding=true' : '';

    this.actionUrl = '/api/?entity=groups&action=crmGroupsImport&crm=wealthbox' + onboardingParam;

    getActiveCrmGroups('wealthbox').then(res => {
      const groups = res.data;
      if (groups && groups.length > 0) {
        self.groups = groups;
      }

      if (groups && groups.length > 0) {
        groups.forEach(function (group) {
          if (group.selected === true) {
            this.selectedGroups.push(group.id);
            this.contactsCount += group.count;
          }
        }, this);
      }
    });
  },
  props: {
    vesselId: {
      required: true,
      type: Number,
    },
    openModalButtonClasses: {
      type: Array,
      default: () => [],
    },
    redirectUrl: {
      required: true,
      type: String,
      default: '/inventory/contacts/groups/',
    },
    actionButtonWrapperClasses: {
      type: Array,
      default: () => [],
    },
    onboarding: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.group-list {
  list-style-type: none;
  max-width: 600px;
  display: block;
  margin: 40px auto 0 auto;

  .group-entry {
    text-align: left;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    transition: ease all 350ms;
    padding: 5px 0;
    padding-left: 12px;
    border-top: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: 1px solid #f0f0f0;
    }
  }

  .group-entry:hover,
  .group-entry.selected {
    background: darken(rgb(102, 204, 204), 20);
    color: #fff;
  }

  .group-count {
    font-size: 17px;
  }
}

.add-vertical-scroll {
  height: 300px;
  overflow-y: scroll;
}

.import-meta {
  margin: 15px 0 0 0;
  color: #fff;
}
</style>
